import React, { PropsWithChildren, useEffect } from 'react';

import { configureDatadog } from '@storebrand-digital/common-datadog';
import { Environment } from '@storebrand-digital/common-datadog/dist/environment';
import { useFlag } from '@unleash/proxy-client-react';

export const DatadogProvider = ({
  children,
}: PropsWithChildren<Record<never, never>>): React.ReactElement => {
  const datadogFeatureIsActive = useFlag('datadog-monitoring');
  useEffect(() => {
    if (getDatadogEnvironment() !== 'development' && datadogFeatureIsActive) {
      configureDatadog({
        environment: getDatadogEnvironment(),
        clientPublicToken: 'pub3a84cec515656835677ef0266c617b7f',
        appId: '3d245d28-6778-47c2-b2ee-dc7e149697ff',
        appName: 'mypages-insurance-web',
        appVersion: process.env.COMMIT_HASH ?? 'undefined',
        configureLogging: true,
        forwardConsoleLogs: ['error', 'warn'],
      });
    }
  }, [datadogFeatureIsActive]);

  return <>{children}</>;
};

const getDatadogEnvironment = (): Environment => {
  const env = window.env.ENVIRONMENT;
  switch (env) {
    case 'e2e':
    case 'development':
      return 'development';
    case 'client-t':
    case 'staging':
      return 'client-t';
    case 'production':
    default:
      return 'production';
  }
};
